import { formatTelemetryAttributes } from './format-telemetry-attributes';
import { formatTelemetryMetrics } from './format-telemetry-metrics';
export function createEventLog({ event = {}, dimensionLookup = {}, metricLookup = {}, }) {
    var _a, _b;
    const { pathname: eventPathname, eventType = 'other' } = event;
    const metrics = formatTelemetryMetrics(event, metricLookup);
    const eventAttributes = formatTelemetryAttributes({
        telemetryData: Object.assign({ eventType }, event),
        dimensionLookup,
        excludeKeys: [
            'workflow',
            'pathname',
            ...Object.keys(metrics),
            ...Object.keys(metricLookup),
        ],
    });
    const telemetryPayload = Object.assign(Object.assign({ name: eventType }, eventAttributes), metrics);
    // Set browser properties if available
    if (typeof document !== 'undefined' && document.referrer) {
        telemetryPayload.referrer = document.referrer;
    }
    if (typeof window !== 'undefined' && !telemetryPayload.hostname) {
        telemetryPayload.hostname = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    }
    telemetryPayload.path =
        typeof window !== 'undefined' && window.location.pathname
            ? (_b = window.location) === null || _b === void 0 ? void 0 : _b.pathname
            : eventPathname;
    return telemetryPayload;
}
//# sourceMappingURL=create-event-log.js.map